import React from 'react';
import { Button, RobbieMark } from '../ui';

/**
 * Robbie-voiced empty/error states for the RFQ list — the mascot carries the
 * attribution (never an "AI" text tag), the copy states the consequence and
 * the next action, and the action button is the one real thing to do next.
 */
interface RobbieNoteProps {
    message: string;
    action?: { label: string; onClick: () => void };
}

export const RobbieNote: React.FC<RobbieNoteProps> = ({ message, action }) => (
    <div className="flex flex-col items-center gap-s4 rounded-card border border-line bg-surface px-s6 py-s7 text-center">
        <RobbieMark size="sm" aria-label="Robbie" />
        <p className="max-w-[440px] text-body-md text-ink-body">{message}</p>
        {action && (
            <Button variant="secondary" size="sm" onClick={action.onClick}>
                {action.label}
            </Button>
        )}
    </div>
);

export default RobbieNote;
